// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.
import { all, fork } from 'redux-saga/effects';
import agingLawsTwingraphQueriesResultSaga from './AgingLawsTwingraphQueries';
import dataVectorTwingraphQueriesResultSaga from './DataVectorTwingraphQueries';
import ganttChartTwingraphQueriesSaga from './GanttChartTwingraphQueries';
import selectedGisementTwingraphQueriesSaga from './SelectedGisementTwingraphQueries';

export default function* wizardSaga() {
  yield all([
    fork(agingLawsTwingraphQueriesResultSaga),
    fork(ganttChartTwingraphQueriesSaga),
    fork(selectedGisementTwingraphQueriesSaga),
    fork(dataVectorTwingraphQueriesResultSaga),
  ]);
}
